export const DecibelFavicon = ({ className }: { className?: string }) => {
  return (
    <svg viewBox="0 0 94 94" fill="none" className={className}>
      <path
        d="M35.4316 48.1772C35.4316 57.3025 32.2459 64.7047 28.3165 64.7047C25.3279 64.7047 22.7683 60.4187 21.7133 54.3496C20.9316 56.6326 19.7244 58.0957 18.3719 58.0957C16.0129 58.0957 14.1001 53.6564 14.1001 48.1805C14.1001 42.7046 16.0129 38.2653 18.3719 38.2653C19.7279 38.2653 20.9316 39.7284 21.7133 42.0114C22.7683 35.9423 25.3279 31.6562 28.3165 31.6562C32.2493 31.6562 35.4316 39.0552 35.4316 48.1838V48.1772Z"
        fill="currentColor"
      />
      <path
        d="M51.665 57.2057C59.8662 52.643 68.1124 51.5998 70.0771 54.8793C71.5714 57.3723 68.9979 61.6517 64.0723 65.5678C66.5144 65.0778 68.4341 65.3545 69.112 66.4843C70.2916 68.4507 67.2546 72.2668 62.3325 75.0064C57.4103 77.746 52.464 78.3692 51.2845 76.4029C50.6065 75.273 51.3191 73.5366 52.9794 71.7402C46.9988 73.8965 41.8657 73.9032 40.3714 71.4069C38.4067 68.1274 43.4637 61.7683 51.6684 57.2057H51.665Z"
        fill="currentColor"
      />
      <path
        d="M51.6655 39.1444C43.4643 34.5818 38.4038 28.2227 40.3685 24.9432C41.8628 22.4502 46.9959 22.4569 52.9765 24.6099C51.3162 22.8168 50.6036 21.0771 51.2816 19.9472C52.4611 17.9809 57.4074 18.6041 62.3296 21.3437C67.2517 24.0833 70.2852 27.8961 69.1092 29.8658C68.4312 30.9956 66.5149 31.2723 64.0694 30.7823C68.9985 34.6951 71.5685 38.9745 70.0742 41.4708C68.1095 44.7503 59.8668 43.7104 51.6621 39.1444H51.6655Z"
        fill="currentColor"
      />
    </svg>
  );
};
